import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ReleasesSection.module.css';
import Ico from '../common/Ico';
import Pill from '../common/Pill';
import Btn from '../common/Btn';
import EmptyState from '../common/EmptyState';
import { statusLabel } from './statusConfig';
import ActorCell from './ActorCell';

const ICO_ROCKET = 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z';
const ICO_TAG    = 'M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01';

export default function ReleasesSection({ releases = [], onTrigger }) {
  return (
    <section className={styles.section} id="sec-releases">
      <div className={styles.header}>
        <span className={styles.iconTile}>
          <Ico d={ICO_ROCKET} size={16} strokeWidth={1.7} />
        </span>
        <div className={styles.headerText}>
          <div className={styles.titleRow}>
            <span className={styles.title}>Official releases</span>
          </div>
          <div className={styles.subtitle}>
            Cuts the official public release tag and publishes all artifacts. Kept for backward compatibility.
          </div>
        </div>
        <Btn variant="soft" size="lg" onClick={onTrigger}>Trigger release</Btn>
      </div>

      {releases.length === 0 ? (
        <EmptyState icon={ICO_TAG} title="No releases yet" hint="Trigger a release from this branch." />
      ) : (
        <div className={styles.list}>
          <div className={styles.listHeader}>
            <span>Version</span>
            <span>Triggered by</span>
            <span>Status</span>
            <span></span>
          </div>
          {releases.map((r) => (
            <div key={r.version} className={styles.releaseRow}>
              <div className={styles.releaseInfo}>
                <span className={styles.releaseIconTile}>
                  <Ico d={ICO_TAG} size={17} strokeWidth={1.7} />
                </span>
                <span className={styles.releaseText}>
                  <span className={styles.releaseVersion}>{r.version}</span>
                  {r.note && <span className={styles.releaseNote}>{r.note}</span>}
                </span>
              </div>
              <ActorCell actor={r.triggered_by} className={styles.actorCell} />
              <span className={styles.statusCell}>
                <Pill status={r.status} dot>{statusLabel(r.status)}</Pill>
              </span>
              <Link to={`/releases/${r.version}`} className={styles.viewBtn}>View release</Link>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
